import React, { createContext, useContext, useMemo } from 'react'
import { useMedia } from 'use-media'
import { breakpoints, mediaQueriesExpressions } from './consts'
import type { Breakpoints, MediaQueryContextType, Props } from './types'

const initialValue: MediaQueryContextType = {
  mobileM: false,
  tablet: false,
  laptopS: false,
  laptop: false,
  desktop: false,
  breakpoints,
  currentBreakpoint: 'mobileM',
}

const MediaQueryContext = createContext<MediaQueryContextType>(initialValue)

export const MediaQueryProvider = ({ children }: Props) => {
  const mobileM = useMedia(mediaQueriesExpressions.mobileM)
  const tablet = useMedia(mediaQueriesExpressions.tablet)
  const laptopS = useMedia(mediaQueriesExpressions.laptopS)
  const laptop = useMedia(mediaQueriesExpressions.laptop)
  const desktop = useMedia(mediaQueriesExpressions.desktop)

  const currentBreakpoint = useMemo((): keyof Breakpoints => {
    if (desktop) {
      return 'desktop'
    }
    if (laptop) {
      return 'laptop'
    }
    if (laptopS) {
      return 'laptopS'
    }
    if (tablet) {
      return 'tablet'
    }
    if (mobileM) {
      return 'mobileM'
    }

    return 'mobileM'
  }, [desktop, laptop, laptopS, mobileM, tablet])

  const value = useMemo(
    () => ({
      mobileM,
      tablet,
      laptopS,
      laptop,
      desktop,
      breakpoints,
      currentBreakpoint,
    }),
    [mobileM, tablet, laptopS, laptop, desktop, currentBreakpoint],
  )

  return <MediaQueryContext.Provider value={value}>{children}</MediaQueryContext.Provider>
}

export const useMediaQueryContext = () => {
  return useContext(MediaQueryContext)
}
